"use client";
import React, { Fragment } from "react";
import Accordion from "@/components/ui/Accordion";
import Card from "@/components/ui/Card";
import Icon from "@/components/ui/Icon";
import { Tab } from "@headlessui/react";

const faqmenus = [
  {
    title: "Getting Started",
  },
  {
    title: "Earnings & Limits",
  },
  {
    title: "Payments & Terms",
  },
];

const items = [
  {
    title: "How do I sign up?",
    content:
      "Sign up for the referral program by creating an account on our website. Once you're registered, you'll receive a unique referral link to start sharing.",
  },
  {
    title: "What is a referral link?",
    content:
      "A referral link is a personalized URL that tracks who you’ve referred to our services. Share this link with your network to earn rewards for successful referrals.",
  },
  {
    title: "How can I share my referral link?",
    content:
      "You can share your referral link via social media, email, text messages, or any other platform where you connect with your network.",
  },
];

const items2 = [
  {
    title: "How much can I earn?",
    content:
      "You can earn 2% up to R5000 for each successful referral. There is no limit to how many people you can refer or how much you can earn!",
  },
  {
    title: "What qualifies as a successful referral?",
    content:
      "A successful referral is when the person you referred signs up through your link and completes a transaction with us.",
  },
  {
    title: "Can I track my referrals?",
    content:
      "Yes, you can track your referrals and earnings through your referral program dashboard.",
  },
];

const items3 = [
  {
    title: "When will I get paid?",
    content:
      "Payouts are processed once the referral completes their transaction. The funds will be transferred directly into your wallet.",
  },
  {
    title: "Are there any terms and conditions?",
    content:
      "Yes, terms and conditions apply to ensure fair use of the program. Be sure to read our referral program policy for full details.",
  },
  {
    title: "What payment methods are supported?",
    content:
      "We offer payments via bank transfers. You’ll be prompted to provide your bank details upon account verification",
  },
];

const FaqRefferal = () => {
  return (
    <div className="pb-8 mt-12">
      <h3 id="FAQ" className="text-center mb-8 text-2xl font-semibold">
        Frequently Asked Questions
      </h3>
      <Tab.Group>
        <div className="grid gap-5 grid-cols-12">
          <div className="xl:col-span-3 lg:col-span-4 col-span-12 card-auto-height">
            <Card>
              <Tab.List className="flex flex-col space-y-1 text-start items-start">
                {faqmenus.map((item, i) => (
                  <Tab key={i} as={Fragment}>
                    {({ selected }) => (
                      <button
                        className={`focus:ring-0 focus:outline-none space-x-2 text-sm flex items-center w-full transition duration-150 px-3 py-4 rounded-[6px] rtl:space-x-reverse
                            ${
                              selected
                                ? "bg-slate-200 dark:bg-slate-900 dark:text-white"
                                : "bg-white dark:bg-slate-800 dark:text-slate-300"
                            }
                         `}
                        type="button"
                      >
                        <span
                          className={`text-lg ${
                            selected
                              ? "opacity-100"
                              : "opacity-50 dark:opacity-100"
                          }`}
                        ></span>
                        <Icon icon="heroicons:chevron-double-right-solid" />
                        <span> {item.title}</span>
                      </button>
                    )}
                  </Tab>
                ))}
              </Tab.List>
            </Card>
          </div>
          <div className="xl:col-span-9 lg:col-span-8 col-span-12">
            <Tab.Panels>
              <Tab.Panel>
                <Accordion items={items} />
              </Tab.Panel>
              <Tab.Panel>
                <Accordion items={items2} />
              </Tab.Panel>
              <Tab.Panel>
                <Accordion items={items3} />
              </Tab.Panel>
            </Tab.Panels>
          </div>
        </div>
      </Tab.Group>
    </div>
  );
};

export default FaqRefferal;
